/** @format */
import React, { FC } from 'react'
import styled from 'styled-components'
import { initLabelCondition, LabelCondition } from '../constants'
import { _$, FormItem, Input, Select, Option, Icon } from '@king-design/react'
import { useAsync } from 'react-use'
import { getMetricLabels } from 'src/api/ApiPrometheusAlarm'
import { cloneDeep } from 'lodash'
import { AddButon } from 'src/components'

interface VisualRuleLabelsProps {
  className?: string
  labels: LabelCondition[]
  onChange: (value: Partial<LabelCondition[]>) => void
  productType: number
  metricKey: string
}

const VisualRuleLabels: FC<VisualRuleLabelsProps> = ({
  className,
  labels,
  onChange,
  productType,
  metricKey
}) => {
  const { value: labelList, loading } = useAsync(async () => {
    if (productType !== undefined && metricKey) {
      const result = await getMetricLabels({
        Product: productType,
        Metric: metricKey
      })
      return result?.Labels || []
    } else {
      return []
    }
  }, [productType, metricKey])

  const onChangeLabel = (value: Partial<LabelCondition>, labelIndex: number) => {
    const copyLabels = cloneDeep(labels)
    if (value) {
      copyLabels[labelIndex] = {
        ...copyLabels[labelIndex],
        ...value
      }
    } else {
      copyLabels.splice(labelIndex, 1)
    }
    onChange(copyLabels)
  }

  return (
    <div className={className}>
      {!loading ? (
        metricKey ? (
          <>
            {labelList?.length ? (
              <>
                {labels?.map((label, labelIndex) => {
                  const { Name, Operator, Value } = label
                  return (
                    <div className="label_item" key={labelIndex}>
                      <FormItem
                        hideLabel
                        value={Name && Operator && Value}
                        rules={{ required: true }}
                      >
                        <Select
                          width={100}
                          value={Name}
                          className="label_item_name"
                          placeholder={_$('标签名')}
                          onChangeValue={value => {
                            onChangeLabel({ Name: value }, labelIndex)
                          }}
                        >
                          {labelList?.map(item => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                        </Select>
                        <Select
                          value={Operator}
                          width={100}
                          placeholder={_$('操作符')}
                          onChangeValue={value => {
                            onChangeLabel({ Operator: value }, labelIndex)
                          }}
                        >
                          <Option value="=">{'='}</Option>
                          <Option value="!=">{'!='}</Option>
                          <Option value="=~">{'=~'}</Option>
                          <Option value="!~">{'!~'}</Option>
                        </Select>
                        <Input
                          width={100}
                          value={Value}
                          className="label_item_value"
                          placeholder={_$('标签值')}
                          onChangeValue={value => {
                            onChangeLabel({ Value: value }, labelIndex)
                          }}
                        />
                      </FormItem>
                      <Icon
                        className="ion-trash-a"
                        size={16}
                        onClick={() => {
                          onChangeLabel(undefined, labelIndex)
                        }}
                      />
                    </div>
                  )
                })}
                <AddButon
                  text={_$('新建维度')}
                  size="small"
                  type="link"
                  disabled={labels?.length >= 3}
                  fluid={false}
                  onClick={() => {
                    const cloneLabels = cloneDeep(labels)
                    onChange(cloneLabels.concat([initLabelCondition]))
                  }}
                />
              </>
            ) : (
              <span className="info_text">{_$('该指标下无维度')}</span>
            )}
          </>
        ) : (
          <span className="info_text">{_$('请先选择指标')}</span>
        )
      ) : null}
    </div>
  )
}

export default styled(VisualRuleLabels)`
  .label_item {
    width: 320px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    & > .k-form-item {
      margin-bottom: 0;
      &.k-invalid .label_item_name {
        border-right: none !important;
      }
    }
    .k-select {
      border-radius: 0;
    }
    .label_item_name {
      border-right: none;
      border-radius: 4px 0 0 4px;
    }
    .label_item_value .k-input-wrapper {
      border-left: none;
      border-radius: 0 4px 4px 0;
    }
    .ion-trash-a {
      margin-left: 9px;
    }
  }
  .info_text {
    color: #999;
  }
`
